import {NgModule} from "@angular/core";
import {EvaCardComponent} from "./eva-card.component";
import {CommonModule} from "@angular/common";
import {IconsModule} from "../icons/icons.module";
import {TagTextModule} from "../tag-text/tag-text.module";
import { EvaButtonModule } from '../eva-button/eva-button.module';
import {OptionalLinkModule} from "../optional-link/optional-link.module";
import { MediaPictureGalleryModule } from "@shopping-angular-components/media-picture-gallery";
import { SliderModule } from "../slider/slider.module";

@NgModule({
    declarations: [
        EvaCardComponent
    ],
    imports: [
        CommonModule,
        IconsModule,
        TagTextModule,
        EvaButtonModule,
        OptionalLinkModule,
        MediaPictureGalleryModule,
        SliderModule
    ],
    exports: [
        EvaCardComponent
    ],
    bootstrap: [EvaCardComponent]
})
export class EvaCardModule {}
